export default __webpack_public_path__ + "static/media/multiexportdata.86190319.png";